import { useEffect } from 'react';
import { useAdminAPI } from './useAdminAPI';
import { getPendingUsers } from '../../../api/adminAPI';

export interface SignupUser {
    userId: number;
    username: string;
    name: string;
    email: string;
    birthDate: string;
    phone: string;
    workplace: string;
    medicalLicenseNumber: string | null;
    specialistNumber: string | null;
    department: string | null;
    position: string | null;
    isSpecialist: boolean | null;
    createdAt: string;
}

interface UsersResponse {
    resultCode: string;
    message: string;
    data: SignupUser[];
}

/**
 * 가입 신청자 목록 조회를 위한 커스텀 훅
 *
 * @returns users, loading, error, refetch
 */
export const useSignupUsers = () => {
    const { data, loading, error, execute, refetch } = useAdminAPI<UsersResponse>(getPendingUsers);

    useEffect(() => {
        execute();
    }, []);

    return {
        users: data?.data || [],
        loading,
        error,
        refetch,
    };
};